"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TableDragulaOptions = /** @class */ (function () {
    function TableDragulaOptions() {
        this.TABLE_COLUMN_OPTIONS = {
            direction: 'horizontal',
            copy: function (el, source) {
                return el.id === "new_field";
            },
            moves: function (el, source, handle) {
                return true;
            }
        };
    }
    return TableDragulaOptions;
}());
exports.TableDragulaOptions = TableDragulaOptions;
//# sourceMappingURL=table-dragula.options.js.map